import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const BookAppointmentModalContext = createContext(null);

export function BookAppointmentModalProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openBookAppointmentModal = useCallback(() => setOpen(true), []);
  const closeBookAppointmentModal = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({
      open,
      openBookAppointmentModal,
      closeBookAppointmentModal,
    }),
    [open, openBookAppointmentModal, closeBookAppointmentModal]
  );

  return (
    <BookAppointmentModalContext.Provider value={value}>
      {children}
    </BookAppointmentModalContext.Provider>
  );
}

export function useBookAppointmentModal() {
  const ctx = useContext(BookAppointmentModalContext);
  if (!ctx) {
    throw new Error('useBookAppointmentModal must be used within BookAppointmentModalProvider');
  }
  return ctx;
}
